/** Parse VITE_* boolean flags (handles quotes and trailing inline comments in .env). */
export function isViteEnvTrue(value: string | undefined): boolean {
  if (value == null || value === '') return false;
  const cleaned = value.split('#')[0]?.trim().replace(/^['"]|['"]$/g, '') ?? '';
  return cleaned === 'true' || cleaned === '1';
}

/** Browser-only; safe when shared is compiled for Node (no DOM lib). */
export function isLocalhostRuntime(): boolean {
  const hostname = (globalThis as { location?: { hostname?: string } }).location?.hostname;
  if (!hostname) return false;
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
}

/**
 * True on production builds served from a non-localhost host (amberpeak.ca, thehivekingston.com).
 * Pass `import.meta.env.PROD` from Vite client code. False for dev, localhost preview, Docker dev.
 */
export function isProductionWebAnalyticsRuntime(isProd: boolean): boolean {
  if (!isProd) return false;
  return !isLocalhostRuntime();
}
